/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileNewsletterContact } from '../../models/profile-newsletter-contact';

export interface ProfileNewsletterCreateContact$Params {
  id: number;
      body: ProfileNewsletterContact
}

export function profileNewsletterCreateContact(http: HttpClient, rootUrl: string, params: ProfileNewsletterCreateContact$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileNewsletterContact>> {
  const rb = new RequestBuilder(rootUrl, profileNewsletterCreateContact.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileNewsletterContact>;
    })
  );
}

profileNewsletterCreateContact.PATH = '/rest/profile/{id}/newsletter/contact';
